var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecenterVesselInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84446 8.95373C2.34834 8.7608 2.10028 8.66433 2.02786 8.52533C1.96508 8.40483 1.96499 8.26129 2.02763 8.14071C2.09989 8.00163 2.34784 7.90486 2.84373 7.71134L16.9169 2.21939C17.3645 2.0447 17.5883 1.95736 17.7314 2.00514C17.8556 2.04663 17.953 2.1441 17.9945 2.26831C18.0423 2.41133 17.955 2.63516 17.7803 3.08281L12.2883 17.1559C12.0948 17.6518 11.998 17.8998 11.859 17.972C11.7384 18.0347 11.5948 18.0346 11.4743 17.9718C11.3353 17.8994 11.2389 17.6513 11.0459 17.1552L8.85584 11.5235C8.81667 11.4228 8.79709 11.3725 8.76685 11.3301C8.74004 11.2925 8.70717 11.2596 8.66959 11.2328C8.62719 11.2026 8.57684 11.183 8.47613 11.1438L2.84446 8.95373Z",
    stroke: "#252525",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecenterVesselInactive);
export default __webpack_public_path__ + "static/media/RecenterVesselInactive.6f64241c43071473b0cdec33558bc1c4.svg";
export { ForwardRef as ReactComponent };